export default __webpack_public_path__ + "static/media/reactivex.08221630.svg";